'use client'

import { LuBuilding2 } from 'react-icons/lu'

export default function AffiliateSection({ partners }: {partners: string[]}) {
	return (
		<div className='relative bg-brandsky-900 pb-20 overflow-hidden'>
			<LuBuilding2 className="absolute bottom-[20px] left-[-40px] w-40 h-40 sm:w-64 sm:h-64 text-white opacity-10 pointer-events-none z-0" />
			<div className='lg:max-w-4xl xl:max-w-5xl 2xl:max-w-7xl mx-auto px-4 relative z-10'>
				<h1 className="text-4xl lg-text-5xl font-bold text-white mb-10 drop-shadow-sm header uppercase text-center">
					Хамтрагч байгууллагууд
				</h1>

				<div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
					{partners && partners.map((src, idx) => (
						<div key={idx} className="bg-white rounded-xl p-5 shadow-md flex items-center justify-center hover:scale-105 transition-transform duration-300 ease-in-out">
							<img
								src={src}
								alt={`Brand ${idx + 1}`}
								className="max-h-16 object-contain"
							/>
						</div>
					))}
				</div>
			</div>
		</div>
	)
}
